var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenanceMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2826 8.75619C16.0264 8.01238 16.3864 7.03058 16.3626 6.05588C16.3519 5.61775 16.0079 5.52194 15.698 5.83179L14.7534 6.77651C13.8549 7.67502 12.9401 7.67502 12.0417 6.77651C11.1431 5.87785 11.1431 4.96342 12.0417 4.06461L12.9863 3.12005C13.2962 2.81034 13.2002 2.46618 12.7622 2.45567C11.7878 2.43218 10.8054 2.79195 10.0621 3.5353C9.02225 4.57506 8.73664 6.07891 9.19596 7.37799L2.91476 13.6592C2.3012 14.2727 2.3012 15.1026 2.91476 15.7163L3.10161 15.9033C3.71517 16.5171 4.54526 16.5171 5.15897 15.9033L11.44 9.62225C12.7392 10.0815 14.2431 9.79549 15.2826 8.75619Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceMenu);
export default __webpack_public_path__ + "static/media/MaintenanceMenu.64ad2fa2.svg";
export { ForwardRef as ReactComponent };